import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Log } from 'ng2-logger';
import { AdminService } from '../../_services/admin.service';
import { ActivatedRoute } from '@angular/router';

const log = Log.create('WhitelistComponent');

@Component({
  moduleId: module.id,
  selector: 'whitelist-component',
  templateUrl: 'whitelist.component.html',
  styleUrls: ['whitelist.less']
})
export class WhitelistComponent implements OnInit {

  _whitelistedItems: any = [];
  _possibleWhitelistItems: any = [];
  _possibleFilterItems: any = [];
  selectedWhitelistItem: any = null;
  _disabled = true;

  _possibleWhitelistItemsMethod: any;
  _possibleWhitelistItemsMethodArgs: any;

  @Input() placeholder = 'Select driver to whitelist';
  @Output() whitelistedItemsChange = new EventEmitter();

  @ViewChild('possibleFilterItemsDropdown') possibleFilterItemsDropdown;
  @ViewChild('possibleWhitelistsDropdown') possibleWhitelistsDropdown;

  get whitelistedItems() { return this._whitelistedItems; }
  get possibleWhitelistItems() { return this._possibleWhitelistItems; }
  get possibleFilterItems() { return this._possibleFilterItems; }

  @Input() set whitelistedItems(whitelistedItems) {
    this._whitelistedItems = [];

    whitelistedItems.map( whitelistedItem => {
      this._whitelistedItems.push({
        id: whitelistedItem.id,
        text: whitelistedItem.name,
        treeName: whitelistedItem.treeName,
        nc12: whitelistedItem.nc12
      });
    });
  }

  @Input() set possibleWhitelistItems(possibleWhitelistItems) {
    this._possibleWhitelistItems = [];

    possibleWhitelistItems.map( possibleWhitelistItem => {
      this._possibleWhitelistItems.push({
        id: possibleWhitelistItem.id,
        text: possibleWhitelistItem.treeName,
        treeName: possibleWhitelistItem.treeName,
        nc12: possibleWhitelistItem.nc12
      });
    });
    this.updateDropdowns();
  }

  @Input() set possibleWhitelistItemsMethod(input){
    this._possibleWhitelistItemsMethod = input[0];
    this._possibleWhitelistItemsMethodArgs = input[1];
  }

  @Input() set possibleFilterItems(possibleFilterItems) {
    this._possibleFilterItems = [];

    possibleFilterItems.map( possibleFilterItem => {
      this._possibleFilterItems.push({
        id: possibleFilterItem.id,
        text: possibleFilterItem.name
      });
    });
    this.updateDropdowns();
  }

  constructor(private admin: AdminService,
              private route: ActivatedRoute) {}

  ngOnInit() {
    this.updateDropdowns();
  }

  private removeWhitelistItem(whitelistedItem) {
    const index = this.whitelistedItems.indexOf(whitelistedItem);
    if (index !== -1) {
      this.whitelistedItems.splice(index, 1);
    }

    this.updateParent();
  }

  private checkIfAddIsDisabled() {
    if (this.selectedWhitelistItem === null) {
      return true;
    }

    for (const whitelistItem of this.whitelistedItems) {
      if (whitelistItem.id === this.selectedWhitelistItem.id){
        return true;
      }
    }
  }

  private addWhitelistItem() {
    for (const possibleWhitelistItem of this.possibleWhitelistItems){
      if (possibleWhitelistItem.id === this.selectedWhitelistItem.id) {
        this.whitelistedItems.push(possibleWhitelistItem);
      }
    }
    this.possibleWhitelistsDropdown.active = null;
    this.updateParent();
  }

  private updateDropdowns() {
    this.possibleWhitelistsDropdown.items = this.possibleWhitelistItems;
    this.possibleFilterItemsDropdown.items = this.possibleFilterItems;
  }

  private onChangeFilter($event) {
    log.info('onchangefilter event', $event);

    if ($event.length === 0) {
      this._disabled = true;
      this.possibleWhitelistItems = [];
      this.possibleWhitelistsDropdown.active = null;

    } else {
      this._disabled = false;

      const filterParentId = $event.id;
      this._possibleWhitelistItemsMethod.call(this.admin, this._possibleWhitelistItemsMethodArgs, filterParentId).subscribe(response => {
        log.info('finally,', response.data);

        this.possibleWhitelistItems = response.data;
      });

    }
  }

  private onChange($event) {
    log.d('onchange fired', $event);
    // user cleared the selection
    if ($event.length === 0) {
      this.selectedWhitelistItem = null;
    } else {
      // user selected a family
      this.selectedWhitelistItem = $event;
    }
  }

  private updateParent() {
    const outputObj = [];
    for (let i = 0; i < this.whitelistedItems.length; i++ ){
      outputObj.push({
        id: this.whitelistedItems[i].id,
        name: this.whitelistedItems[i].text,
        treeName: this.whitelistedItems[i].treeName,
        nc12: this.whitelistedItems[i].nc12
      });
    }

    this.whitelistedItemsChange.emit(outputObj);
  }
}



// WEBPACK FOOTER //
// ./src/app/_component/whitelist/whitelist.component.ts